import {
  decodeToken,
  getClaim as getClaimDomain,
  getPermissionsFromToken as getPermissionsDomain,
  getRolesFromToken,
  isTokenExpired,
} from "@hotel/domain";

export { decodeToken, getRolesFromToken, isTokenExpired };

export const getClaim = (decodedToken, keys, fallback = "") => {
  const value = getClaimDomain(decodedToken, keys);
  return value !== null && value !== undefined && value !== "" ? value : fallback;
};

export const getPermissionsFromToken = (decodedToken) => {
  const perms = getPermissionsDomain(decodedToken);
  if (perms.length === 1 && typeof perms[0] === "string" && perms[0].includes(",")) {
    return perms[0].split(/[,\s]+/).map((p) => p.trim()).filter(Boolean);
  }
  return perms;
};
